import * as React from "react";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import {PlaceholderProps} from "../../common/props/PlaceholderProps";
import {FormGroupProps} from "../../common/props/FormGroupProps";
import {FocusableProps} from "../../common/props/FocusableProps";
import KeywordMultiSelector from "./KeywordMultiSelector";
import {none, option, Option} from "ts-option";
import {InputActionMeta} from "react-select/lib/types";

type Props = FormGroupProps<string[]> & PlaceholderProps & FocusableProps & PlaceholderProps;

interface State {
	/**
	 * Text displayed when create mail and validation error
	 */
	promptText: string
	/**
	 * Selector input value
	 */
	inputValue: string;
}

export default class KeywordsFormGroup extends React.PureComponent <Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {promptText: "Create keyword:", inputValue: ""};
		this.onChange = this.onChange.bind(this);
		this.onInputChange = this.onInputChange.bind(this);
		this.onAdd = this.onAdd.bind(this);
		this.isUnique = this.isUnique.bind(this);
	}

	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().getOrElse("")}>
				<KeywordMultiSelector items={none}
									  value={this.props.field.getOptionalValue()}
									  inputValue={this.state.inputValue}
									  clearable={true}
									  onChanged={this.onChange}
									  onAddOption={this.onAdd}
									  onInputChange={this.onInputChange}
									  multi
									  promptTextCreator={(filterText) => `${this.state.promptText} ${filterText}`}
									  onInputKeyDown={() => {this.setState({promptText: "Create keyword:"})}}
									  getNewOptionData={(value, label) => label}/>
			</FormGroup>
		)
	}

	/**
	 * Callback on changed keywords list.
	 * @param data
	 */
	onChange(data: Option<string[]>) {
		this.props.onChange(this.props.field.updateValue(data.isDefined && data.get.length > 0 ? data : none))
	}

	/**
	 * Selector input change callback.
	 * @param {string} inputValue
	 * @param {InputActionMeta} inputActionMeta
	 */
	onInputChange(inputValue: string, inputActionMeta: InputActionMeta) {
		if (inputActionMeta.action === 'input-change') {
			this.setState({inputValue});
		}
	}

	/**
	 * Callback on add new email.
	 * @param {string} newItem
	 */
	onAdd(newItem: string) {
		if (newItem.trim().length > 0) {
			if (this.isUnique(newItem, this.props.field.getOptionalValue().getOrElse([]))) {
				this.setState({inputValue: ""},
					() => this.props.onChange(this.props.field.updateValue(
						option(this.props.field.value.getOrElse([]).concat(newItem)))));
			}
			else {
				this.setState({promptText: "Keyword already exists: "});
			}
		}
	}

	/**
	 * Check if option is unique
	 * @param {string} newItem
	 * @param {string[]} options
	 * @returns {boolean}
	 */
	isUnique(newItem: string, options: string[]) {
		return !options.filter(i => i == newItem).length;
	}
}